import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

export default class SignupHandler {
	constructor() {
		this.started = false;
		this.paytourHelper = window.paytourHelper;
		this.paytourInitObject = {
			'targetUrl': '',
			'pfm': 1502,
			'host': 0,
			'hideClose': false,
			'disableJump': true
		};

		helper.addEventListener(window, Events.START_ACTION, () => {
			this.started = true;
		});

		helper.addEventListener(window, Events.VIDEO_LIMIT_REACHED, () => {
			this.paytourInitObject.hideClose = true;
		});

		helper.addEventListener(window, Events.CREATE_SIGNUP, () => {
			if (this.started) {
				this._handleSignup();
			}
		});

		helper.addEventListener(window, Events.VIDEO_CHANGED, (evt) => {
			this.paytourInitObject.host = evt.detail.uid;
		});
	}

	_handleSignup() {
		const $info = helper.$('#information');
		const ab1 = parseInt(helper.getData($info, 'ab1'));
		const adtv = helper.getData($info, 'adtv');

		// Open Paytour in mother page
		if (ab1 === 1) {
			window.top.postMessage({action: 'open sesame', adtv: adtv, host: this.paytourInitObject.host}, '*');
			return;
		}

		let $vxRegistrationForm = helper.$('#vxRegistrationForm');

		if ($vxRegistrationForm === null) {
			vxSignupComponent.initVXSignupForm(helper.$('#commentbox'));
			$vxRegistrationForm = helper.$('#vxRegistrationForm');
			helper.addEventListener($vxRegistrationForm, 'animationend', (evt) => {
				if (evt.animationName === 'shakeVertical') {
					helper.removeClass($vxRegistrationForm, 'shake');
				}
			});

			helper.addEventListener(window, Events.SENT_MESSAGE, () => {
				helper.addClass($vxRegistrationForm, 'shake');
			});
		} else {
			helper.addClass($vxRegistrationForm, 'shake');
		}
	}
}
